import React from 'react';

import { ButtonProps, Text } from '@rover/kibble/core';
import IconBlock from '@rover/kibble/patterns/IconBlock';

import SquareButton from './SquareButton';

type Props = ButtonProps & {
  icon: React.ComponentProps<typeof IconBlock>['icon'];
  title: React.ComponentProps<typeof IconBlock>['title'];
  subtitle?: string;
  flex?: string;
};

const SquareIconButton: React.FC<Props> = ({
  icon,
  title,
  subtitle,
  flex,
  ...buttonProps
}: Props) => {
  return (
    <SquareButton flex={flex} {...buttonProps}>
      <IconBlock icon={icon} iconSize="32px" size="200" title={title} overrideTitleTopMargin="0x">
        {subtitle && (
          <Text sx={{ color: 'neutral[800]' }} textAlign="left" fontWeight="regular">
            {subtitle}
          </Text>
        )}
      </IconBlock>
    </SquareButton>
  );
};
export default SquareIconButton;
